<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="620" persistent>
      <v-card class="np-card">
        <v-card-title class="np-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="deep-orange darken-3">mdi-history</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">Historial académico</div>
              <div class="text-body-2 white--text opacity-80">
                Inscripción #{{ inscrito.id }}
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4 pb-4" style="max-height: 520px; overflow-y: auto;">

          <div v-if="loading" class="d-flex align-center justify-center py-8" style="gap: 12px;">
            <v-progress-circular indeterminate color="deep-orange" size="28" />
            <span class="grey--text">Cargando historial...</span>
          </div>

          <div v-else-if="!historial.length" class="text-center py-8 grey--text">
            <v-icon large color="grey lighten-2">mdi-timeline-outline</v-icon>
            <div class="mt-2 caption">Sin registros de historial</div>
          </div>

          <v-timeline v-else dense class="hist-timeline pt-2">
            <v-timeline-item
              v-for="(item, i) in historial"
              :key="i"
              :color="estadoColor(item)"
              :icon="estadoIcono(item)"
              fill-dot
              small
            >
              <div class="hist-item">
                <!-- Transición de estado -->
                <div class="d-flex align-center flex-wrap mb-1" style="gap: 6px;">
                  <span v-if="item.estado_anterior" class="estado-chip estado-chip--prev">
                    {{ item.estado_anterior.nombre }}
                  </span>
                  <v-icon v-if="item.estado_anterior" x-small color="grey">mdi-arrow-right</v-icon>
                  <span class="estado-chip" :class="`estado-chip--${item.estado_actual.codigo.toLowerCase()}`">
                    {{ item.estado_actual.nombre }}
                  </span>
                </div>

                <!-- Evento + origen -->
                <div class="d-flex align-center mb-1" style="gap: 6px;">
                  <v-chip x-small outlined :color="eventoColor(item.evento)" class="hist-chip">
                    <v-icon x-small left>{{ eventoIcono(item.evento) }}</v-icon>
                    {{ item.evento }}
                  </v-chip>
                  <v-chip x-small outlined color="grey" class="hist-chip">
                    {{ item.origen }}
                  </v-chip>
                </div>

                <!-- Payload relevante -->
                <div v-if="payloadTexto(item.payload)" class="hist-payload">
                  <span v-for="(txt, j) in payloadTexto(item.payload)" :key="j" class="hist-payload-item">
                    <v-icon x-small>{{ txt.icon }}</v-icon> {{ txt.label }}
                  </span>
                </div>

                <!-- Fechas -->
                <div class="hist-fechas">
                  <v-icon x-small color="grey lighten-1">mdi-clock-outline</v-icon>
                  {{ formatFecha(item.fecha_inicio) }}
                  <template v-if="item.fecha_fin">
                    <span class="mx-1 grey--text">—</span>
                    {{ formatFecha(item.fecha_fin) }}
                    <span class="hist-duracion ml-1">({{ duracion(item.fecha_inicio, item.fecha_fin) }})</span>
                  </template>
                  <span v-else class="ml-1 caption deep-orange--text">en curso</span>
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';

  export default {
    data() {
      return {
        loading: false,
        dialog: false,
        inscrito: {},
        historial: [],
      };
    },
    methods: {
      async openmodal(row) {
        this.inscrito = row;
        this.historial = [];
        this.dialog = true;
        this.cargar_historial();
      },
      async cargar_historial() {
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${this.inscrito.id}/estado-administrativo/historial`;
        this.loading = true;
        const r = await xaxios.get(url).then(({ data }) => data).catch(e => e);
        this.loading = false;
        if (r && r.data) {
          this.historial = r.data.historial || [];
        }
      },
      cerrar() {
        this.dialog = false;
      },
      estadoColor(item) {
        const retroceso = item.estado_anterior && item.estado_actual.id < item.estado_anterior.id;
        if (retroceso) return 'red darken-1';
        const mapa = { PROSPECTO: 'blue-grey', PREINSCRITO: 'orange', INSCRITO: 'green darken-1' };
        return mapa[item.estado_actual.codigo] || 'grey';
      },
      estadoIcono(item) {
        const retroceso = item.estado_anterior && item.estado_actual.id < item.estado_anterior.id;
        if (retroceso) return 'mdi-undo';
        const mapa = { PROSPECTO: 'mdi-account-clock', PREINSCRITO: 'mdi-account-check', INSCRITO: 'mdi-school' };
        return mapa[item.estado_actual.codigo] || 'mdi-circle-small';
      },
      eventoColor(evento) {
        const mapa = { PAGO: 'green', JOB_AUTO: 'blue-grey', CAMBIO_MANUAL: 'deep-orange' };
        return mapa[evento] || 'grey';
      },
      eventoIcono(evento) {
        const mapa = { PAGO: 'mdi-cash', JOB_AUTO: 'mdi-robot', CAMBIO_MANUAL: 'mdi-pencil' };
        return mapa[evento] || 'mdi-circle-small';
      },
      payloadTexto(payload) {
        if (!payload) return null;
        const items = [];
        if (payload.monto_total) items.push({ icon: 'mdi-cash', label: `Bs. ${payload.monto_total}` });
        if (payload.receipt_id) items.push({ icon: 'mdi-receipt', label: `Recibo #${payload.receipt_id}` });
        if (payload.motivo_anulacion) items.push({ icon: 'mdi-alert-circle-outline', label: payload.motivo_anulacion.replace(/_/g, ' ') });
        return items.length ? items : null;
      },
      formatFecha(fecha) {
        if (!fecha) return '';
        const d = new Date(fecha);
        return d.toLocaleString('es-BO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
      },
      duracion(inicio, fin) {
        const diff = new Date(fin) - new Date(inicio);
        const seg = Math.floor(diff / 1000);
        if (seg < 60) return `${seg}s`;
        const min = Math.floor(seg / 60);
        if (min < 60) return `${min}m`;
        return `${Math.floor(min / 60)}h ${min % 60}m`;
      },
    },
    mounted() {},
  };
</script>

<style scoped>
.np-card { border-radius: 14px; overflow: hidden; }
.np-hero { background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%); }

.hist-timeline { padding-left: 4px; }

.hist-item {
  background: #f9f9f9;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 2px;
}

/* Estado chips */
.estado-chip {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  letter-spacing: 0.3px;
}
.estado-chip--prev {
  background: #eeeeee;
  color: #757575;
}
.estado-chip--prospecto   { background: #eceff1; color: #546e7a; }
.estado-chip--preinscrito { background: #fff3e0; color: #e65100; }
.estado-chip--inscrito    { background: #e8f5e9; color: #2e7d32; }

.hist-chip { font-size: 10px !important; height: 18px !important; }

.hist-payload {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
}
.hist-payload-item {
  font-size: 11px;
  color: #555;
  display: flex;
  align-items: center;
  gap: 3px;
}

.hist-fechas {
  font-size: 10.5px;
  color: #9e9e9e;
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 4px;
}
.hist-duracion {
  font-size: 10px;
  color: #bdbdbd;
}
</style>
